module.exports = __webpack_public_path__ + "img/4.16d1c812.svg";